import {FAQ} from './FAQ';
import {Shop} from './Shop';
import {SignIn} from './SignIn';
import {SignUp} from './SignUp';
import {Filter} from './Filter';
import {Reviews} from './Reviews';
import {Product} from './Product';
import {Checkout} from './Checkout';
import {MyAddress} from './MyAddress';
import {AddANewCard} from './AddANewCard';
import {EditProfile} from './EditProfile';
import {OrderFailed} from './OrderFailed';
import {NewPassword} from './NewPassword';
import {Description} from './Description';
import {OrderHistory} from './OrderHistory';
import {MyPromocodes} from './MyPromocodes';
import {PaymentMethod} from './PaymentMethod';
import {LeaveAReviews} from './LeaveAReviews';
import {ForgotPassword} from './ForgotPassword';
import {AddANewAddress} from './AddANewAddress';
import {TrackYourOrder} from './TrackYourOrder';
import {OrderSuccessful} from './OrderSuccessful';
import {VerifyYourEmail} from './VerifyYourEmail';
import {ConfirmationCode} from './ConfirmationCode';
import {MyPromocodesEmpty} from './MyPromocodesEmpty';
import {OrderHistoryEmpty} from './OrderHistoryEmpty';
import {ShippingAPaymentInfo} from './ShippingAPaymentInfo';
import {EmailHasBeenVerified} from './EmailHasBeenVerified';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {CheckoutPaymentMethod} from './CheckoutPaymentMethod';
import {VerifyYourPhoneNumber} from './VerifyYourPhoneNumber';
import {ShippingAndPaymentInfo} from './ShippingAndPaymentInfo';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import {CheckoutShippingDetails} from './CheckoutShippingDetails';
import {PhoneNumberHasBeenVerified} from './PhoneNumberHasBeenVerified';

export const screens = {
  FAQ,
  Shop,
  SignIn,
  Filter,
  SignUp,
  Reviews,
  Product,
  Checkout,
  MyAddress,
  EditProfile,
  Description,
  OrderFailed,
  NewPassword,
  AddANewCard,
  OrderHistory,
  MyPromocodes,
  PaymentMethod,
  LeaveAReviews,
  ForgotPassword,
  TrackYourOrder,
  AddANewAddress,
  VerifyYourEmail,
  OrderSuccessful,
  ConfirmationCode,
  OrderHistoryEmpty,
  MyPromocodesEmpty,
  ShippingAPaymentInfo,
  SignUpAccountCreated,
  EmailHasBeenVerified,
  CheckoutPaymentMethod,
  VerifyYourPhoneNumber,
  ShippingAndPaymentInfo,
  CheckoutShippingDetails,
  ForgotPasswordSentEmail,
  PhoneNumberHasBeenVerified,
};
